import {
    buildingService
} from "@/_services"

export const namespaced = true

export const state = {
    currentBuilding: {},
    currentExpense: {},
    buildings: [],
    numberOfAllowedBuildings: 0
}

export const getters = {
    getBuildingById: state => id => {
        return state.buildings.find(building => building.id === id)
    }
}

export const actions = {
    createFreshBuilding({
        commit
    }) {
        commit('SET_CURRENT_BUILDING', {})
    },
    fetchBuildingsAll({
        commit
    }) {
        buildingService.getAll()
            .then(response => {
                commit('SET_BUILDINGS', response.buildings)
                var allowedBuildings = 0
                if (response.numberOfAllowedBuildings)
                    allowedBuildings = response.numberOfAllowedBuildings
                commit('SET_NUMBER_OF_ALLOWED_BUILDINGS', allowedBuildings)
            })

    },
    fetchBuildingsOfUser({
            commit
        },
        userId
    ) {
        buildingService.getBuildingsOfUser(userId)
            .then(response => {
                commit('SET_BUILDINGS', response.buildings)
                var allowedBuildings = 0
                if (response.numberOfAllowedBuildings)
                    allowedBuildings = response.numberOfAllowedBuildings
                commit('SET_NUMBER_OF_ALLOWED_BUILDINGS', allowedBuildings)
            })

    },
    fetchBuildingsOfComplex({
            commit
        },
        complexId
    ) {
        buildingService.getBuildingsOfComplex(complexId)
            .then(response => {
                commit('SET_BUILDINGS', response.buildings)
                var allowedBuildings = 0
                if (response.numberOfAllowedBuildings)
                    allowedBuildings = response.numberOfAllowedBuildings
                commit('SET_NUMBER_OF_ALLOWED_BUILDINGS', allowedBuildings)
            })

    },
    fetchBuilding({
        commit,
        getters
    }, id) {
        var building = getters.getBuildingById(id)
        if (building) {
            commit('SET_CURRENT_BUILDING', building)
        } else {
            buildingService.getById(id)
                .then(response => {
                    commit('SET_CURRENT_BUILDING', response)
                })

        }
    },

    fetchExpenseOfBuilding({
        commit
    },
        expenseId
    ) {
        buildingService.getExpenseById(expenseId)
            .then(response => {
                commit('SET_EXPENSE', response)
               
            })

    }

}
export const mutations = {
    ADD_BUILDING(state, building) {
        state.buildings.push(building)
    },

    SET_BUILDINGS(state, buildings) {
        state.buildings = buildings
    },

    SET_EXPENSE(state, expense) {
        state.currentExpense = expense.expenseType
    },

    SET_NUMBER_OF_ALLOWED_BUILDINGS(state, numberOfAllowedBuildings) {
        state.numberOfAllowedBuildings = numberOfAllowedBuildings
    },

    SET_CURRENT_BUILDING(state, building) {
       state.currentBuilding = building
    },
    CLEAR_CURRENT_BUILDING(state){
        state.currentBuilding ={}
    },
    CLEAR_BUILDINGS(state){
        state.buildings =[]
    }
}